<template>
  <el-dialog title="KM角色管理" :visible.sync="dialogVisible" width="60%" custom-class="dialogHeight dialogPaddingTop0 ">
    <div class="km-dialog">
      <!-- <el-divider content-position="left">角色选择</el-divider> -->
      <p class="smallHeader">角色选择</p>
      <el-row>
        <el-col :span="24">
        <el-checkbox-group v-model="checkedKMRoles">
          <el-checkbox label="0001">员工</el-checkbox>
          <el-checkbox label="0010">部门知识管理员</el-checkbox>
          <el-checkbox label="0020">专委会知识管理员</el-checkbox>
          <el-checkbox label="0100">企业知识管理员</el-checkbox>
        </el-checkbox-group> 
        </el-col>
      </el-row>
      
      <el-row>
        <el-col :span="24">
          <span class="tip-text">（选择需要设置KM角色的用户，此次设置将会清空用户原来的角色设置，未选择的用户将不受影响）</span>
        </el-col>
      </el-row>
      <el-divider></el-divider>
      <el-row>
        <el-col :span="18">
        <el-form :inline="true" :model="searchdata" class="demo-form-inline" size="small" @submit.native.prevent>
            <el-form-item >
                <el-input v-model="searchdata.data.name"  @keyup.enter.native="searchTableData"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button @click="searchTableData" type="primary" plain>{{$t('query')}}</el-button>
                <el-button @click="resetSearchTableData">{{$t('reset')}}</el-button>
            </el-form-item>
            
        </el-form>
        </el-col>
      </el-row>
      <!-- 用户列表 -->
      <el-table :data="tableData.datas"
          @selection-change="onSelectionChange"
          header-cell-class-name="tableHeaderbg" stripe>
          <el-table-column type="selection" width="55" ></el-table-column>
          <el-table-column prop="name" label="用户姓名"></el-table-column>
          <el-table-column prop="loginno" label="账号"></el-table-column>
          <el-table-column prop="email" label="邮箱"></el-table-column>
      </el-table>
      <!-- 分页 -->
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="searchTableData"
            :current-page.sync="searchdata.currpage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="searchdata.pagelines"
            layout="prev, pager, next, total, sizes"
            background
            :total="tableData.rowCount?tableData.rowCount:0"
          ></el-pagination>    
      
    </div>
    <div  slot="footer" class="dialog-footer">
      <el-row>
        <el-col :span="24" class="align-right">
          <el-button type="primary" @click="onOk" size="small">{{$t('confirm')}}</el-button>
          <el-button @click="onCancel" size="small">{{$t('cancel')}}</el-button>
        </el-col>
      </el-row>
    </div>
  </el-dialog>  
</template>

<script>

export default {
  props: ["visible"],
  created(){
    this.searchTableData();
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      }
    }
  },
  data() {
    return {
      searchdata: {
        domainid: this.$route.query.domainid,
        departmentid: "",
        currpage: 1,
        pagelines: 10,
        orderby: "",
        data:{
          name: "",
          loginno: "",
          superiorname: "",
          roleid: "",
        }
      },  
      tableData: {},
      multipleSelection: [],
      deptUser: [],
      // kmdata: kmdataOptions,
      checkedKMRoles: [],
    };    
  },
  methods: {
    resetSearchTableData(){
      this.searchTableData();
    },
    handleSizeChange(size){
      this.searchdata.pagelines=size;
      this.searchTableData();
    },
    searchTableData() {
      this.$api.getUsers(this.searchdata, {
        onSucess: resp => {
          this.tableData = resp.data.data;
        }
      });
    },
    onOk(){
      let rowids = [];
      this.multipleSelection.forEach(row => {
        rowids.push(row.id);
      });
      this.ids=rowids.join(",");
      this.kmRoleSelectItem = this.checkedKMRoles.join(",");
      if(this.ids.length==0){
        this.$message({
          showClose: true,
          message: "请选择用户",
          type: "error"
        });
        return false;
      }
      if(this.kmRoleSelectItem.length==0){
        this.$message({
          showClose: true,
          message: "请选择角色",
          type: "error"
        });
        return false;
      }
      let datas = {};
      datas["kmRoleSelectItem"] = this.kmRoleSelectItem;
      datas["ids"] = this.ids;
      this.$api.updatekmconfig(
        {
          domainid: this.$route.query.domainid,
          data: datas
        },  
        {
        onSucess: resp => {
          if (resp.data.errcode == 0) {
            this.$message({
              showClose: true,
              message: "保存成功",
              type: "success"
            });
            this.onCancel();
          } else {
            this.$message({
              showClose: true,
              message: resp.data.errmsg,
              type: "error"
            });
          }
        }
      });
    },
    onCancel() {
      this.$emit("update:visible", false);
    },
    onSelectionChange(rows) {
      this.multipleSelection = rows;
    },
  },
}
</script>